var appNav = {
	templateUrl: './app-nav.html',
	controller: 'AppNavController',
	controllerAs: 'vm'
};

angular
	.module('common')
	.component('appNav', appNav);
